import { defineMessages, type MessageDescriptor } from 'react-intl';

export const messages: {
	giveFeedbackLabel: MessageDescriptor;
} = defineMessages({
	giveFeedbackLabel: {
		id: 'twg-microsite.collectFeedback.giveFeedbackLabel',
		defaultMessage: 'Give feedback',
		description:
			'Accessible label for the floating megaphone IconButton that opens the feedback dialog on the TWG microsite home page.',
	},
});
